export const PENDING_PRODUCT_ID_KEY = 'pendingProductId';

export function isValidProductIdParam(value: string | null): value is string {
  return value !== null && /^\d+$/.test(value);
}

export function storePendingProductId(id: string): void {
  localStorage.setItem(PENDING_PRODUCT_ID_KEY, id);
}

export function consumePendingProductId(): string | null {
  const id = localStorage.getItem(PENDING_PRODUCT_ID_KEY);
  if (id) {
    localStorage.removeItem(PENDING_PRODUCT_ID_KEY);
  }
  return id;
}

export function buildProductShareUrl(productId: number): string {
  return `${window.location.origin}/dashboard?product=${productId}`;
}

/** After login, prefer a pending product deep link, then report link, then plain dashboard. */
export function resolvePostLoginDashboardPath(): string {
  const pendingProductId = consumePendingProductId();
  if (isValidProductIdParam(pendingProductId)) {
    return `/dashboard?product=${pendingProductId}`;
  }

  const pendingReportLink = localStorage.getItem('pendingReportLink');
  if (pendingReportLink) {
    localStorage.removeItem('pendingReportLink');
    return `/dashboard?report=${pendingReportLink}`;
  }

  return '/dashboard';
}
